import type { TAppConfig } from "~ui/@application/configs/config-schema.ts";

import { createI18n, type I18nOptions } from "vue-i18n";
import { ELocale, INITIAL_LOCALE } from "~application/constants/locale.constant.ts";
import { ENGLISH_LOCALE } from "~ui/@application/locales/en.ts";
import { FRENCH_LOCALE } from "~ui/@application/locales/fr.ts";

export type TVoltexploitMessageSchema = typeof FRENCH_LOCALE;

const dateTimeSchema = {
  short: {
    year: "numeric",
    month: "short",
    day: "numeric",
  },
  table: {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  },
  long: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
  },
  dateLong: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "long",
  },
} as const;

export const VoltexploitI18nOptions: I18nOptions = {
  legacy: false,
  locale: INITIAL_LOCALE,
  fallbackLocale: INITIAL_LOCALE,
  messages: {
    [ELocale.FRENCH]: FRENCH_LOCALE,
    [ELocale.ENGLISH]: ENGLISH_LOCALE,
  },
  datetimeFormats: {
    [ELocale.FRENCH]: dateTimeSchema,
    [ELocale.ENGLISH]: dateTimeSchema,
  },
};

export function createI18nConfig(appConfig: TAppConfig) {
  void appConfig;

  // biome-ignore lint/suspicious/noExplicitAny: shhhht
  return createI18n<typeof VoltexploitI18nOptions>(VoltexploitI18nOptions as any);
}
